import store from "store2";
import germanI18n from "../../assets/i18n/de.json";

import "dayjs/locale/de";
import "dayjs/locale/en";

/**
 * The localstorage key for the apps language
 */
export const LANGUAGE_STORAGE_KEY = "starlight__AppLanguage";

/**
 * Singleton service that provides language related functionality
 */
class LanguageService {
    /**
     * Returns the current language while prioritizing the language stored in localstorage
     */
    public getCurrentLocale(): string {
        // HINT: This is uncommented since for now we are not supporting non-german languages
        // if (!store.has(LANGUAGE_STORAGE_KEY)) {
        //     store.set(LANGUAGE_STORAGE_KEY, this.convertToBaseLocale(navigator.language));
        // }
        //
        // return store.get(LANGUAGE_STORAGE_KEY) as string;
        const locale = "de";
        document.documentElement.lang = locale;
        return locale;
    }
    /**
     * Persists the provided language key in the localstorage
     * @param newVal    The new value
     */
    public setLanguage(newVal: string) {
        const locale = this.convertToBaseLocale(newVal);
        store.set(LANGUAGE_STORAGE_KEY, locale);
        document.documentElement.lang = locale;
    }

    /**
     * Gets an object of the supported languages and their translations
     */
    public getSupportedLanguages() {
        return {
            // en: { translation: englishI18n },
            de: { translation: germanI18n },
        };
    }

    /**
     * Converts a locale string to its base locale (e.g. de-DE to de)
     * @param locale    The locale string to convert
     * @private
     */
    private convertToBaseLocale(locale: string) {
        if (locale.includes("-")) {
            return locale.slice(0, locale.indexOf("-"));
        }
        return locale;
    }
}

/**
 * The singleton instance of the language service
 */
export const languageService = new LanguageService();
